import ApiHook from './axiosAPI'

const { apiGET, apiPOST } = ApiHook()

const PedidoAPI = {
  BuscarPedidoId: async idpedido => {
    const url = `/pedidos/buscarPorId/?id=${idpedido}`
    const req = await apiGET(url)
    return req
  },
  BuscarReagendamentoPorPedido: async idpedido => {
    const url = `/pedidos/buscarReagendamentosPorPedido/?idpedido=${idpedido}`
    const req = await apiPOST(url)

    return req
  },
  BuscarMensalistaId: async idmensalista => {
    const url = `/mensalista/buscarPorId/?id=${idmensalista}`
    const req = await apiGET(url)
    return req
  },
  BuscarDiariaId: async idcompraDayuse => {
    const url = `/dayuse/buscarCompraPorId/?id=${idcompraDayuse}`

    const req = await apiGET(url)
    return req
  },
  BuscarRegraCancelamentoId: async idregraCancelamento => {
    const url = `/regraCancelamento/buscarPorId/?idregraCancelamento=${idregraCancelamento}`
    const req = await apiGET(url)
    if (req.error) {
      // console.error(req.error)
    }
    return req
  },
  BuscarPagamentoId: async idpagamento => {
    const url = `/pagamentos/buscarPorId/?id=${idpagamento}`
    return await apiGET(url)
  },
  CancelarAgendamento: async data => {
    const url = `/pedidos/cancelarPedidoPorUsuario/`
    const req = await apiPOST(url, data)
    return req
  },
  VerificarCupom: async cupom => {
    const url = `/cupom/verificarCupom/?isGestor=false`
    const req = await apiPOST(url, cupom)
    return req
  },
}

export default PedidoAPI
